export default {
  common: {
    filters: {
      startingDate: {
        label: 'Starting date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      endDate: {
        label: 'End date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      skus: {
        label: 'SKU(s)',
        placeholder: 'Select SKU(s)'
      },
      operationIds: {
        label: 'Operation Id(s)',
        placeholder: 'Select operation id(s)'
      },
      operators: {
        label: 'Operator(s)',
        placeholder: 'Select operator(s)'
      },
      statuses: {
        label: 'Status(es)',
        placeholder: 'Select status(es)'
      },
      acquirerMsisdns: {
        label: 'Acquirer phone number(s)',
        placeholder: 'Acquirer phone number(s)'
      },
      acquirer_msisdn: {
        label: 'Acquirer phone number',
        placeholder: 'Acquirer phone number'
      },
      resultsNumber: {
        label: 'Number of results to display at page'
      }
    }
  }
};
